export default __webpack_public_path__ + "static/media/9.71c7e117.jpg";